import React from 'react';
import { Modal, Fade } from '@mui/material';
import { useAuth } from '../authContext';
import { useProject } from '../ProjectContext';
import './OnboardingPopup.css';

const OnboardingPopup = ({
  open,
  onBrowse,
  onAddPlace,
  onClose,
  onDismissForever,
  onSignIn,
  onCreateAccount,
  isExhibitionMode,
  customTitle,
  customMessage,
}) => {
  const { user, userFirstName } = useAuth();
  const { project } = useProject();

  const projectLabel = project?.project_name
    ? `MAP250 \u00B7 ${project.project_name.toUpperCase()} PROJECT`
    : 'MAP250';

  // In exhibit mode the admin-configured exhibition_title/exhibition_message
  // override the default "Welcome back, {name}" / "Welcome to Map250" copy so
  // the kiosk can display exhibition-specific branding.
  const heading = customTitle
    || (user ? `Welcome back, ${userFirstName || 'there'}` : 'Welcome to Map250');

  const description = customMessage
    || 'An interactive map that invites you to add stories about places you know by time and place and to explore stories that others have added.';

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slotProps={{ backdrop: { timeout: 500 } }}
      className="onboarding-overlay"
    >
      <Fade in={open} timeout={500}>
        <div className="onboarding">
          <div className="onboarding__strip" />

          <div className="onboarding__body">
            <p className="onboarding__project-label">{projectLabel}</p>

            <h2 className="onboarding__heading">{heading}</h2>

            <p className="onboarding__description">{description}</p>

            <div className="onboarding__buttons">
              <button
                className="onboarding__btn onboarding__btn--browse"
                onClick={onBrowse}
              >
                Browse the map
              </button>
              <button
                className="onboarding__btn onboarding__btn--add"
                onClick={onAddPlace}
              >
                Add a place
              </button>
            </div>

            <div className="onboarding__footer">
              <div className="onboarding__divider" />

              {!user && (
                <>
                  <p className="onboarding__auth-prompt">
                    Want to save your contributions and edit them later?
                  </p>
                  <p className="onboarding__auth-links">
                    <button
                      className="onboarding__auth-link"
                      onClick={onSignIn}
                    >
                      Sign in
                    </button>
                    {' or '}
                    <button
                      className="onboarding__auth-link"
                      onClick={onCreateAccount}
                    >
                      Create a free account
                    </button>
                  </p>
                </>
              )}

              {!isExhibitionMode && (
                <button
                  type="button"
                  className="onboarding__dismiss"
                  onClick={onDismissForever}
                >
                  Don&rsquo;t show this screen again
                </button>
              )}
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default React.memo(OnboardingPopup);
